const contactEmail = "cooperation-lines@flixbus.com";

export default contactEmail;
